import React from 'react';
import { Layout } from 'antd';
import { SiderProps } from 'antd/lib/layout';

export type LayoutSiderProps = SiderProps;

const ProLayoutSider: React.FC<LayoutSiderProps> = React.forwardRef<
  any,
  LayoutSiderProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return (
    <Layout.Sider ref={ref} {...resProps}>
      {children}
    </Layout.Sider>
  );
});

export default ProLayoutSider;
